import type { CompareProduct } from './compareProvider';

/**
 * Flattens the products being compared into parallel arrays for analytics
 * payloads (e.g. the "Opened Compare Modal" event). Parallel scalar arrays —
 * rather than an array of objects — keep each property filterable and
 * breakable-down in Mixpanel. Index N across the arrays describes the same
 * product. Shared by Bloom and the shared-ecomm menu so both pipelines emit an
 * identical payload shape.
 */
export interface CompareProductsTrackingSummary {
  productBrands: (string | null)[];
  productCategories: (string | null)[];
  productIds: number[];
  productKinds: string[];
  productNames: string[];
}

export const compareProductsTrackingSummary = (
  products: CompareProduct[]
): CompareProductsTrackingSummary => ({
  productBrands: products.map((product) => product.brand),
  productCategories: products.map((product) => product.category),
  productIds: products.map((product) => product.id),
  productKinds: products.map((product) => product.kind),
  productNames: products.map((product) => product.name),
});
